// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Shelf_carouselContainer__Ug2j6","divider":"Shelf_divider__pqLer","horizontalContainer":"Shelf_horizontalContainer__4tg97","hideButton":"Shelf_hideButton__6blZf"};